module.exports = __webpack_public_path__ + "static/media/download-files.9aebf29c.svg";